import api from "./api";

const ArticleAPI = {
    getById: (id) => api.get(`/articles/details/${id}`),
    getRecent: (count) => api.get(`/articles/recent/${count}`),
    update: (data) => api.post(`/articles/update`, data),
    insert: (data) => api.post(`/articles/insert`, data),
    delete: (id) => api.delete(`/articles/delete/${id}`),
    getPaged: (params) => api.get(`/articles/paged?${params}`),
};

export default ArticleAPI;